//
//

import { mapActions, mapGetters } from "vuex";
import columns from "./columns.js";
import DeleteDialogue from "../Dialogs/DeleteDialog";

export default {
    components: {
        DeleteDialogue
    },
    data() {
        return {
            columns,
            paginationControl: { rowsPerPage: 15, page: 1 },
            filter: "",
            showDeleteDlg: false,
            uiToBeDeleted: {}
        };
    },
    computed: {
        ...mapGetters("admin", ["uiList", "loadingUIs"])
    },
    methods: {
        ...mapActions("admin", ["getUIList", "deleteUI"]),
        deleteItem(ui) {
            this.deleteUI(ui);
        },
        openDeleteDlg(ui) {
            this.uiToBeDeleted = ui;
            this.showDeleteDlg = true;
        },
        checkDeleteResponse($event) {
            if ($event.response === true) {
                this.deleteItem(this.uiToBeDeleted);
            }
            this.showDeleteDlg = false;
        }
    },
    mounted() {
        this.getUIList();
    }
};
